import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api, clearDisplayKey, hasDisplayKey } from "../lib/api";

const NONE = { viewer: false, admin: false };

// Server is the source of truth: null = checking, otherwise roles {viewer, admin, method, email, name, display}
export function useAuth() {
  const location = useLocation();
  const [roles, setRoles] = useState(() => location.state?.user || null);
  useEffect(() => {
    if (location.state?.user) return;
    const hadDisplayKey = hasDisplayKey();
    api
      .get("/auth/me")
      .then((r) => {
        // a display key that no longer opens the board was revoked (or mistyped) – tell the screen
        if (!r.data.viewer && hadDisplayKey) {
          clearDisplayKey();
          setRoles({ ...NONE, displayInvalid: true });
        } else setRoles(r.data);
      })
      .catch(() => setRoles(NONE));
  }, [location.state]);
  // 401 from a protected call: the cookie is gone, drop local state without a round-trip
  const signOut = useCallback(() => setRoles(NONE), []);
  // Explicit "Sign out": clears cookies / Google session server-side first (and the display key on this device)
  const logout = useCallback(async () => {
    clearDisplayKey();
    try {
      await api.post("/auth/logout");
    } finally {
      setRoles(NONE);
    }
  }, []);
  return [roles, setRoles, signOut, logout];
}
